<script>
    export let field;
</script>

<h2
    class="text-sm md:text-lg font-bold tracking-tight text-slate whitespace-pre-line mb-4">
    {field.title}
</h2>
